<template>
  <div id="UnitDetail">
    <Drawer
        :title="editTitle"
        v-model="showDrawer"
        width="620"
        :mask-closable="false"
    >
      <Form ref="infoForm" :model="infoFormData" :rules="ruleValidate" label-position="left" :label-width="115" :label-colon="true">
        <FormItem label="会员单位名称" prop="unit_name">
          <Input v-model="infoFormData.unit_name" placeholder="请输入会员单位名称"/>
        </FormItem>
        <FormItem label="视频封面" prop="logo">
          <Upload
              :max-size="imageMaxSize"
              :format="['jpg','jpeg','png']"
              accept="image/jpeg,image/jpg,image/png,"
              action="http://www.sjgzg.com/api/web/upload/image"
              :on-exceeded-size="onExceededSizeAction"
              :on-success="onUploadSuccess"
          >
            <div v-if="!infoFormData.logo" class="image-btn">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
            <img v-else :src="infoFormData.logo" class="image-btn">
            <!-- format支持的文件类型，与 accept 不同的是，format 是识别文件的后缀名，accept 为 input 标签原生的 accept 属性，会在选择文件时过滤，可以两者结合使用 -->
            <!--            <Button icon="ios-cloud-upload-outline">Upload files</Button>-->
          </Upload>
        </FormItem>
        <FormItem label="负责人" prop="link_man">
          <Input v-model="infoFormData.link_man" placeholder="请输入负责人姓名"/>
        </FormItem>
        <FormItem label="联系电话" prop="link_phone">
          <Input v-model="infoFormData.link_phone" placeholder="请输入会员身份证号"/>
        </FormItem>
        <FormItem label="会员单位地址" prop="address">
          <Input v-model="infoFormData.address" placeholder="请输入会员单位地址"/>
        </FormItem>
        <FormItem label="协会简介" prop="introduction">
          <Input type="textarea" :rows="4" v-model="infoFormData.introduction" placeholder="请输入所属分盟"/>
        </FormItem>
      </Form>
      <div style="text-align: right;">
        <Button style="margin-right: 8px" @click="cancelAction">取 消</Button>
        <Button type="primary" @click="saveAction">保 存</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import {editMemberUnitInfo} from "@/request/members";

export default {
  name: "UnitDetail",
  // 注册组件
  components: {},
  props: {},
  // 计算属性，用来监控自己定义的变量，该变量不在data里面声明，直接在computed里面定义，然后就可以在页面上进行双向数据绑定展示出结果或者用作其他处理
  computed: {},
  data () {
    return {
      imageMaxSize: 2048,
      editTitle: '',
      showDrawer: false,
      infoFormData: {
        unit_name: '',
        logo: '',
        logo_name: '',
        link_man: '',
        link_phone: '',
        introduction: '',
        address: ''
      },
      ruleValidate: {
        unit_name: [
          { required: true, message: '请输入会员单位名称', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '请上传会员单位LOGO', trigger: 'blur' }
        ],
        link_man: [
          { required: true, message: '请输入负责人姓名', trigger: 'blur' }
        ],
        link_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        introduction: [
          { required: true, message: '请输入会员单位简介', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入会员单位地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onExceededSizeAction() {
      let imageMaxSize = Math.floor(this.imageMaxSize / 1024);
      this.$Notice.warning({
        title: `图片大小不能超过${imageMaxSize}M`
      });
    },
    onUploadSuccess(response, file, fileList) {
      // console.log("上传成功", response, file, fileList)
      let {imageUrl, fileName} = response.data
      this.infoFormData.logo = imageUrl
      this.infoFormData.logo_name = fileName
    },
    editUnitInfo(action, unitInfo) {
      this.infoFormData = action === 'create'
          ? {
            $edit: 'create',
            unit_name: '',
            link_man: '',
            link_phone: '',
            introduction: '',
            address: ''
          }
          : {
            $edit: 'update',
            ...unitInfo
          };

      this.editTitle = action === 'create' ? '添加会员单位' : '编辑会员单位';

      this.showDrawer = true;
    },
    cancelAction() {
      this.$refs['infoForm'].resetFields();
      this.showDrawer = false;
    },
    saveAction() {
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          editMemberUnitInfo({ unitInfo: this.infoFormData }).then(res=> {
            let { error, message } = res.data
            if (error === 200) {
              this.$Notice.success({
                title: '成功提示',
                desc: message
              })
              this.$refs['infoForm'].resetFields();
              this.showDrawer = false;
              // 调用父组件，刷新证书列表
              this.$emit('refresh');
            }else {
              this.$Notice.error({
                title: '错误提示',
                desc: message
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
